export const getSalesForceSignUpUrl = state => {
  const salesForceDataSource = state.data_sources.find(ds => ds.isSalesForce);
  return salesForceDataSource ? `${salesForceDataSource.path}?redirect_url=${window.location.href}` : null;
};

export const getJiraSignUpUrl = state => {
  const jiraDataSource = state.data_sources.find(ds => ds.slug === 'jira');
  return jiraDataSource ? `${jiraDataSource.path}&redirect_url=${window.location.href}` : null;
};

export const getAsanaSignUpUrl = state => {
  const asanaDataSource = state.data_sources.find(ds => ds.slug === 'asana');
  return asanaDataSource ? `${asanaDataSource.path}&redirect_url=${window.location.href}` : null;
};

export const getHubspotSignUpUrl = state => {
  const hubspotDataSource = state.data_sources.find(ds => ds.slug === 'hubspot');
  return hubspotDataSource ? `${hubspotDataSource.path}&redirect_url=${window.location.href}` : null;
};

export const getFigmaSignUpUrl = state => {
  const figmaDataSource = state.data_sources.find(ds => ds.slug === 'figma');
  return figmaDataSource ? `${figmaDataSource.path}&redirect_url=${window.location.href}` : null;
};

export const getOnedriveSignUpUrl = state => {
  const onedriveDataSource = state.data_sources.find(ds => ds.slug === 'office-365-onedrive-individual-authorization');
  return onedriveDataSource ? `${onedriveDataSource.path}&redirect_url=${window.location.href}` : null;
};

export const getGoogleDriveSignUpUrl = state => {
  const googleDriveDataSource = state.data_sources.find(ds => ds.isGoogleDrive);
  return googleDriveDataSource
    ? `${state.data_sources.find(ds => ds.isGoogleDrive).path}&redirect_url=${window.location.href}`
    : null;
};
